// extracted by mini-css-extract-plugin
export default {"container":"notificationMsg_container__Jjuup","notiContent":"notificationMsg_notiContent__FFNNG"};